import React from "react"
import { HoverCard, HoverCardContent, HoverCardTrigger } from "./TooltipPopoverPrimitive"
import { AntdIconWrap } from "../Icons/AntdIconWrap"
import { classNames } from "../../../utils/classNames"

type Props = {
    isVisible?: boolean
    tooltipClassName?: string
    className?: string
    content: string | React.ReactNode
    children: React.ReactNode
    isInlineElement?: boolean
    align?: "start" | "center" | "end"
    side?: "top" | "left" | "right" | "bottom"
    onOpenChange?: (open: boolean) => void
}

/** Wrapping component for any element that should have tooltip on hover.
Refactored to use TooltipPopoverPrimitive without affecting components that was already using TooltipPopover  */
export const TooltipPopover = ({
    isVisible,
    tooltipClassName,
    className,
    content,
    children,
    isInlineElement = false,
    align,
    side,
    onOpenChange,
}: Props) => {
    return (
        <HoverCard
            openDelay={0}
            closeDelay={0}
            {...(isVisible !== undefined ? { open: isVisible } : {})}
            onOpenChange={onOpenChange}>
            <HoverCardTrigger className={className}>
                {isInlineElement ? <div className={"inline-block"}>{children}</div> : children}
            </HoverCardTrigger>
            <HoverCardContent align={align} side={side ?? "bottom"} className={tooltipClassName}>
                {content}
            </HoverCardContent>
        </HoverCard>
    )
}

export const TooltipInfoIcon = ({ className }: { className?: string }) => (
    <AntdIconWrap type="info-circle" className={classNames("cursor-pointer text-[16px]", className)} />
)
